import compress from 'browser-image-compression';
import { FormGeneratorOnSubmitParams } from 'react-form-builder';
import { transliterate } from 'ui/utils';

export const compressImage = async (file: File, { maxSizeMB = 1 } = {}): Promise<File> => {
  const compressed = await compress(file, {
    maxSizeMB,
    maxWidthOrHeight: 300,
    fileType: 'image/jpeg',
  });

  return new File([compressed], file.name, { type: compressed.type });
};

const fileNameRegExp = /^[^а-яА-ЯёЁ]*$/;

export const fileToBase64 = (file: File, withType = false): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result?.toString()?.split(',')[1];
      if (typeof base64String !== 'string') {
        reject(new Error('Failed to convert file to base64'));
        return;
      }
      let fileName = file.name;
      if (!fileNameRegExp.test(fileName)) {
        fileName = transliterate(fileName); //reject(new Error('Failed to convert file to base64'));
      }

      const base64StringWithType = `data:${file.type};name=${fileName.replaceAll(
        ' ',
        '_',
      )};base64,${base64String}`;

      resolve(withType ? base64StringWithType : base64String);
    };
    reader.onerror = error => {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
};

export const validateBase64TotalSize = (
  formResults: FormGeneratorOnSubmitParams[],
  maxMb = 5,
): { valid: boolean; totalMb: number } => {
  const MAX_BYTES = maxMb * 1024 * 1024;

  const getBase64Size = (dataUrl: string) => {
    const base64 = dataUrl.split(',')[1];
    if (!base64) return 0;

    const len = base64.length;
    const padding = base64.endsWith('==') ? 2 : base64.endsWith('=') ? 1 : 0;
    return (len * 3) / 4 - padding;
  };

  let totalBytes = 0;

  for (const item of formResults) {
    const values = Array.isArray(item.value) ? item.value : [item.value];

    for (const v of values) {
      if (typeof v === 'string' && v.startsWith('data:') && v.includes(';base64,')) {
        totalBytes += getBase64Size(v);
      }
    }
  }

  return {
    valid: totalBytes <= MAX_BYTES,
    totalMb: Number((totalBytes / 1024 / 1024).toFixed(2)),
  };
};
